import React, { useState } from "react";
import { Button, Modal, Carousel, Slider, List } from 'antd';
import { SVGicon } from "../SVGicon/SVGicon";
import submissionVerificationOne from "../../assets/images/cover-images/submissionVerificationOne.png";
import submissionVerificationTwo from "../../assets/images/cover-images/submissionVerificationTwo.png";
import "../../styleGuide/StyleGuide.css";

const marks = {
    0: '0 hires',
    1200: '1200 hires',
};


function AntCarouselPrevArrow(props) {
    const { className, style, onClick, icon } = props;
    return (
        <div
            style={{ ...style }}
            onClick={onClick}
            className={className}
        >
            {icon}
        </div>
    );
}

function AntCarouselNextArrow(props) {
    const { className, style, onClick, icon } = props;
    return (
        <div
            style={{ ...style }}
            onClick={onClick}
            className={className}
        >
            {icon}
        </div>
    );
}

export const Demo = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const onChange = (currentSlide) => {
        console.log(currentSlide);
    };
    const [currentValue, setCurrentValue] = useState(0)

    return (
        <>
            <div className="mtp-container">
                <div className="popup-carousel flex-center w-100 px-16 py-16">
                    <Button type="prime" className="CustomButton" onClick={() => setModalOpen(true)}>
                        Tour
                    </Button>
                    <Modal
                        title=""
                        centered
                        visible={modalOpen}
                        footer={null}
                        wrapClassName="mtp-modal"
                        onOk={() => setModalOpen(false)}
                        onCancel={() => setModalOpen(false)}
                        width={800}
                        closeIcon={SVGicon.mtpIconClose}
                        className="mtp-modal-body-padding-none"
                    >
                        <Carousel
                            className="mtp-carousel"
                            afterChange={onChange}
                            arrows={true}
                            adaptiveHeight={true}
                            // className="antCarouselNavigator antCarouselPrev tourCarouselButton"
                            prevArrow={<AntCarouselPrevArrow icon={SVGicon.mtpIconLeftArrow} />}
                            nextArrow={<AntCarouselNextArrow icon={SVGicon.mtpIconRightArrow} />}>

                            <div className="submission-verification-modal-wrap">
                                <h6 className="fw-600 text-color-alpha text-center">Content Submission and Verification</h6>
                                <p className="fw-400  text-color-bravo text-center">Welcome to your Metropolis Employer Center! We know the reviews on your company profile are a hot topic & really important to you, so we want to share as much information as possible about our user verification processes & content submission policies here at Metropolis.</p>
                                <div className="submission-verification-modal-image">
                                    <div className="submission-verification-modal-image-wrap flex-center flex-center-auto-0 contain-image">
                                        <img src={submissionVerificationOne} alt="submissionVerificationOne" />
                                    </div>
                                </div>
                            </div>


                            <div className="submission-verification-modal-wrap">
                                <h6 className="fw-600 text-color-alpha text-center">Content Submission and Verification</h6>
                                <p className="fw-400  text-color-bravo text-center mb-2">We rely on our users to self certify the truthfulness of their own review and their relationship to a company before submitting any content. We aim to verify as much of our data as possible but the truth is, we’re unable to fully confirm our users identities, the truthfulness of their employment status.</p>
                                <p className="fw-400  text-color-bravo text-center">To help uphold the integrity, quality, & authenticity of the reviews found on our site & to ensure our confidence in the information we’re providing while balancing fairness to Employers, we have the following Metropolis policies in place.</p>
                                <div className="submission-verification-modal-image-wrap flex-center flex-center-auto-0 contain-image">
                                    <img src={submissionVerificationTwo} alt="submissionVerificationTwo" />
                                </div>
                            </div>

                            <div className="submission-verification-modal-wrap">
                                <h6 className="fw-600 text-color-alpha text-center mb-4">Content Submission and Verification</h6>
                                <List className="submission-verification-modal-list">
                                    <List.Item>
                                        <p className="fw-400 text-color-alpha">We require that all users create a Metropolis account before submitting any content.</p>
                                    </List.Item>
                                    <List.Item>
                                        <p className="fw-400 text-color-alpha">We require that all users abide by our Community Guidelines & Review Submission Policies.</p>
                                    </List.Item>
                                    <List.Item>
                                        <p className="fw-400 text-color-alpha">We have Verification Processes & Proprietary algorithms to help detect Fraudulent Activity.</p>
                                    </List.Item>
                                    <List.Item>
                                        <p className="fw-400 text-color-alpha">We allows users to write only one review, per employer, per year, per review type.</p>
                                    </List.Item>
                                    <List.Item>
                                        <p className="fw-400 text-color-alpha">We don’t take sides in factual disputes, so we expect our users to satand behind the statements in their reviews.</p>
                                    </List.Item>

                                </List>
                            </div>

                            <div className="submission-verification-modal-wrap">
                                <h6 className="fw-600 text-color-alpha text-center">Content Submission and Verification</h6>
                                <p className="fw-400  text-color-bravo text-center mb-2">We encourage you to flag content if you believe it violates our guidelines so our team can take another look. Stay mindful that Flagging Reviews is never a guarantee of removal & content decisions are within our sole discretion.</p>
                                <p className="fw-400  text-color-bravo text-center mb-2"> Please watch our Content & Community Video for deeper insights or visit our Help Center to Contact Us with questions.</p>
                                <div className="submission-verification-modal-video cover-image flex-center">
                                    <video src="https://designsupply-web.com/public/samplecontent/vender/codepen/20181014.mp4" controls>
                                    </video>
                                </div>
                            </div>

                        </Carousel>
                    </Modal>
                </div>
            </div>
        </>
    )
}